import { type StackProps, VStack } from '@adc/parallax-component-library';

const MainContainer = ({ ...props }: StackProps) => {
  return (
    <VStack
      backgroundColor="$surface.background"
      justifyContent="space-between"
      style={[{ minHeight: '-webkit-fill-available', height: '100dvh' }]}
      {...props}
    />
  );
};

export { MainContainer };
